import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
export default {
  data: function data() {
    return {
      searchForm: {
        businessContactId: ""
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据

      dialogVisible: false,
      // 弹窗状态
      currentRow: {},
      currentType: "",
      businessContactId: "",
      businessContactList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getBusinessContactList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  computed: {
    getTableData: function getTableData() {
      var _this2 = this;
      if (this.searchForm.businessContactId) {
        return this.tableData.filter(function (item) {
          return item.quarterBusinessContact.id == _this2.searchForm.businessContactId || item.brandBusinessContact.id == _this2.searchForm.businessContactId;
        });
      } else {
        return this.tableData;
      }
    }
  },
  methods: {
    setBusinessContact: function setBusinessContact() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this3.$api.setBusinessContact({
                id: _this3.currentRow.id,
                type: _this3.currentType,
                businessContactId: _this3.businessContactId
              });
            case 1:
              _this3.dialogVisible = false;
              _this3.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    itemClick: function itemClick(id) {
      this.businessContactId = id;
    },
    setBusinessContactDialog: function setBusinessContactDialog(row, type) {
      this.currentRow = row;
      this.currentType = type;
      if (type == "quarter") {
        this.businessContactId = row.quarterBusinessContact.id;
      } else if (type == "brand") {
        this.businessContactId = row.brandBusinessContact.id;
      } else if (type == "bnb") {
        this.businessContactId = row.bnbBusinessContact.id;
      }
      this.dialogVisible = true;
    },
    getBusinessContactList: function getBusinessContactList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$api.getBusinessContactList();
            case 1:
              res = _context3.v;
              _this4.businessContactList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getData: function getData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this5.tableLoading = true;
              _context4.n = 1;
              return _this5.$api.getBusinessContactConfig();
            case 1:
              res = _context4.v;
              _this5.tableData = res.data;
              _this5.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              res = null;
              if (!_this6.form.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this6.$api.updateSocialMedia(_this6.form);
            case 1:
              res = _context5.v;
              _context5.n = 4;
              break;
            case 2:
              _context5.n = 3;
              return _this6.$api.addSocialMedia(_this6.form);
            case 3:
              res = _context5.v;
            case 4:
              _this6.dialogVisible = false;
              _this6.form = {};
              _this6.getData();
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};